import PropTypes from 'prop-types';
import breakPoints from 'helpers/Styles';
import 'react-responsive-carousel/lib/styles/carousel.min.css';
import ProductCardAccessories from 'components/ProductCardAccessories';
import React from 'react';

const AccessoriesProductCards = ({
  products,
  buttonLabel,
  fixedPrice,
  readyToShip,
  pageCounter,
}) => {
  let productArr = [];
  products.every((itm, index) => {
    if (index == pageCounter) {
      return false;
    }
    productArr.push(itm);
    return true;
  });

  return (
    <div>
      <div className="productCard_section">
        {productArr.map((product, idx) => (
          <React.Fragment key={idx}>
            <ProductCardAccessories
              key={product.title1}
              item={product}
              buttonLabel={buttonLabel}
              fixedPrice={fixedPrice}
            />
          </React.Fragment>
        ))}
      </div>
      <div className="productCard_section_mobile">
        {productArr.map((product, idx) => (
          <React.Fragment key={idx}>
            <ProductCardAccessories
              key={product.title1}
              item={product}
              buttonLabel={buttonLabel}
              fixedPrice={fixedPrice}
            />
          </React.Fragment>
        ))}
      </div>
      <style jsx>
        {`
          .productCard_section {
            display: flex;
            flex-wrap: wrap;
            gap: 36px;
            justify-content: center;
            align-items: start;
          }
          .productCard_section_mobile {
            display: none;
          }
          @media (max-width: ${breakPoints.medium}) {
            .productCard_section {
              display: none;
              flex-wrap: wrap;
              gap: 36px;
            }
            .productCard_section_mobile {
              overflow: hidden;
              display: block;
            }
          }
        `}
      </style>
    </div>
  );
};

AccessoriesProductCards.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  products: PropTypes.array.isRequired,
  buttonLabel: PropTypes.string,
  fixedPrice: PropTypes.bool,
  readyToShip: PropTypes.bool,
};

AccessoriesProductCards.defaultProps = {
  buttonLabel: 'START CUSTOMISING',
  fixedPrice: false,
  readyToShip: false,
};

export default AccessoriesProductCards;
